import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import panels from './part3.panels.components'
import {clearResource, setStepperState} from 'redux/actions'
import {connect} from 'react-redux'
import AccordionPart from "pages/purchaser/MyProcedure/scenes/components/AccordionPart";
import HeaderService from "services/HeaderService";
import createButton, {createSubmitFormButton} from "components/complex/floatingMenu/createButton";
import RouterPath from "libs/RouterPath";
import MailIcon from "@material-ui/icons/Mail";
import ForumIcon from '@material-ui/icons/Forum'
import reduxStore from "redux/store";
import DemandSectionsService from "services/DemandSectionsService";
import {DemandValidation, DemandValidationKeys} from "constants/DemandValidation";
import RealizationValuePopup from "./panels/components/RealizationValuePopup";
import ArrowIcon from "@material-ui/icons/KeyboardArrowUp";
import DemandRelatedObjectsPopup from "components/popup/relatedObjects/DemandRelatedObjectsPopup";
import ListIcon from "@material-ui/icons/List";
import DemandService from "services/DemandService";
import PrivilegeService from "services/PrivilegeService";
import SaveIcon from "@material-ui/icons/Save";


function Part3(
    {
        stepperState,
        setStepperState,
        clearResource,
        steps,
        match,
        location,
        demandValidation,
        demandHeader,
        rfxPrivileges = {}
    }) {
    const id = match.params.id;
    const [working, setWorking] = useState(true);
    const [realizationValuesPopupOpened, setRealizationValuesPopupOpened] = useState(false);
    const [relatedObjectPopup, setRelatedObjectPopup] = useState(false);

    useEffect(() => {
        const p2 = HeaderService.get(id);
        const p1 = DemandSectionsService.getEvaluationSections(id);
        const p3 = DemandService.getBuyerPrivileges(id);
        const p4 = DemandService.getBuyerRfxPrivileges(id);
        Promise.all([p1, p2, p3, p4]).then(() => setWorking(false));

        return () => {
            reduxStore.dispatch(setStepperState(null));
            DemandSectionsService.clearDemandValidationResources();
            PrivilegeService.cleanupPrivileges(PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY)
            HeaderService.clear();
        };
        // eslint-disable-next-line
    }, []);

    const navigationBarButtons = () => {
        const buttons = [];
        buttons.push(createButton('email_list', () => {
            const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_EMAIL_LIST_ID, {id: id});
            RouterPath.redirect(href)
        }, undefined, MailIcon, 'primary', false, true));

        if (!!rfxPrivileges.CORRESPONDENCE) {
            buttons.push(createButton('correspondence', () => {
                const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_CORRESPONDENCE_ID, {id: id});
                RouterPath.redirect(href)
            }, undefined, ForumIcon, 'primary', false, true));
        }

        if (demandHeader && (demandHeader.hasPlanItems || demandHeader.hasPurchaseRequests)) {
            buttons.push(createButton('related_objects', () => setRelatedObjectPopup(true),
                "outlined", ListIcon, 'primary', false, true));
        }

        if (demandValidation) {
            const section = demandValidation.find(x => x.section === DemandValidation.PART_3_SECTION);
            if (section && section.showUpdateRealizationValue) {
                buttons.push(createButton('realization_demand_value', () => setRealizationValuesPopupOpened(true),
                    'outlined', undefined, 'primary', false, false));
            }
        }

        const isSaveButton = !!stepperState && stepperState === DemandValidationKeys.EVALUATION_ADDITIONAL_INFO;
        buttons.push(createSubmitFormButton(isSaveButton ? "save" : "close",
            undefined,
            isSaveButton ? SaveIcon : ArrowIcon,
            'primary',
            stepperState === null,
            isSaveButton)
        );
        return buttons;
    }

    return (<>
            <AccordionPart working={working} steps={steps} panels={panels} navigationBarButtons={navigationBarButtons()}/>
            {realizationValuesPopupOpened && <RealizationValuePopup
                demandId={id}
                onSuccess={() => setRealizationValuesPopupOpened(false)}
                onCancel={() => setRealizationValuesPopupOpened(false)}
                editable
            />
            }
            {
                relatedObjectPopup &&
                <DemandRelatedObjectsPopup demandId={id} onClose={() => setRelatedObjectPopup(false)}/>
            }
        </>
    )
}

Part3.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    stepperState: state.stepper.state,
    steps: state.stepper.steps[2].steps,
    demandValidation: state.resources.demandValidation,
    rfxPrivileges: state.privileges[PrivilegeService.RFX_PRIVILEGE_STORE_KEY],
    form: state.form,
}), {
    setStepperState,
    clearResource
})(Part3);